import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { SNACKBAR_FEATURE, SnackbarState, StateWithSnackbar } from '../snackbar-state';

export const getSnackbarFeatureState: MemoizedSelector<StateWithSnackbar, SnackbarState> =
  createFeatureSelector<SnackbarState>(SNACKBAR_FEATURE);
